/**
 * @Description 预估销售额
 */

import React, { FC, useMemo } from 'react';
import { Typography } from 'antd';
import { TimeDimensionMap } from './index';
import { floorKeep, isNotEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';
const { Text } = Typography;

/**
 * @description 格式化预测营业额相关数据
 * @param data
 * @returns {val, unit, title}
 */
export const formatPredictSale = (data: any) => {
  const getTargetNum = (num: number) => {
    return (+floorKeep(num, 10000.0, 4, 1) as number).toFixed(1);
  };

  const {
    salesAmountPredict, // 预测营业额
    lowSalesAmountPredict,
    upSalesAmountPredict,
    timeDimension,
  } = data || {};

  const title = `预测${TimeDimensionMap.get(timeDimension) || ''}营业额`;

  // 优先展示区间，无区间值时展示具体值
  const canShowRange = isNotEmpty(lowSalesAmountPredict) && isNotEmpty(upSalesAmountPredict);
  const canShowValue = isNotEmpty(salesAmountPredict);
  if (canShowRange) {
    let unit = '元';
    let val = `${lowSalesAmountPredict}-${upSalesAmountPredict}`;
    if (lowSalesAmountPredict >= 10000 || upSalesAmountPredict >= 10000) {
      unit = '万元';
      val = `${getTargetNum(lowSalesAmountPredict)}-${getTargetNum(upSalesAmountPredict)}`;
    }
    return {
      val,
      unit,
      title,
    };
  } else if (canShowValue) {
    let unit = '元';
    let val = salesAmountPredict;
    if (salesAmountPredict >= 10000) {
      unit = '万元';
      val = getTargetNum(salesAmountPredict);
    }
    return {
      val,
      unit,
      title,
    };
  }
  return {
    val: '',
    unit: '',
    title,
  };
};

interface V2PredictProps {
  style?: React.CSSProperties;
  className?: string;
  data: any;
  valWidth?: number;
};
const V2Predict: FC<V2PredictProps> = ({
  style,
  className,
  data,
  valWidth,
}) => {

  const value = useMemo(() => {
    return formatPredictSale(data);
  }, [data]);

  return (
    <div className={cs(styles.V2PredictCon, className)} style={style}>
      <div className={styles.illustrationImg}>
        <img src='https://staticres.linhuiba.com/project-custom/locationpc/selectionmap/icon_turnover@3x.png' width='100%' height='100%'/>
      </div>
      <div>
        <div>
          {/* <span className='fs-14 c-ff9 bold'>{value.val}</span> */}
          <Text
            style={{ width: valWidth ? `${valWidth}px` : '100%' }}
            ellipsis={{ tooltip: `${value.val}${value.unit}` }}
            className='fs-14 c-ff9 bold'
          >
            <span>
              {value.val}
              <span className='c-222 fs-12 fwNormal'>{value.unit}</span>
            </span>
          </Text>
        </div>
        <div className='fs-12 c-999 mt-2'>
          {value.title}
        </div>
      </div>
    </div>
  );
};

export default V2Predict;
